import { UL } from '@wheely/ui-kit';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { useExternalLinks } from '@/app/hooks/useExternalLinks';
import { useLicensingAuthorityTypes } from '@/shared/hooks/useLicensingAuthorityTypes';

import s from './styles.module.css';

const LicensingAuthorityMissing = () => {
  const links = useExternalLinks();
  const licensingAuthorities = useLicensingAuthorityTypes();

  return (
    <div className={s.wrapper}>
      <p>
        <FormattedMessage
          defaultMessage="To work with Wheely you need to be licensed by one of the following authorities:"
          id="YMS1iI"
          description="Missing licensing authority description"
        />
      </p>
      <UL>
        {licensingAuthorities.map(
          licensingAuthority =>
            licensingAuthority.link && (
              <li key={licensingAuthority.value}>
                <a href={licensingAuthority.link} target="_blank" rel="noreferrer">
                  {licensingAuthority.title}
                </a>
              </li>
            ),
        )}
      </UL>
      <p>
        <FormattedMessage
          defaultMessage="If you have a car, note that you MUST hold a PHV and PHD that are licensed with the same authority, otherwise, you would not be able to work as a Wheely chauffeur."
          id="SFe0sn"
          description="Missing licensing authority description"
        />
      </p>
      <p>
        <FormattedMessage
          defaultMessage="Detailed information about available licensing options can be found <link>here</link>."
          id="ELHs6c"
          description="Missing licensing authority description"
          values={{
            link: (text: ReactNode) => (
              <a href={links.licensingAuthorities} target="_blank" rel="noreferrer">
                {text}
              </a>
            ),
          }}
        />
      </p>
    </div>
  );
};

export { LicensingAuthorityMissing };
